/* import __COLOCATED_TEMPLATE__ from './select-category.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { SavingsAccountMetadata } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { SAVINGS_CATEGORIES_TO_ENUMS } from '@banking/ui/utils/constants';
import { AccountState } from '@square/dashboard-protos/models/squareup/banking/common';
import { computed } from '@ember/object';
import { Action, getEvent, Page } from '@banking/ui/utils/folder-cdp-events';
let SelectCategory = (_dec = computed('foldersAccounts.openFoldersAccounts', 'savingsAccounts.accounts'), _dec2 = computed('foldersAccounts.openFoldersAccounts', 'savingsAccounts.accounts', 'showSalesTaxRow'), _dec3 = computed('foldersAccounts.openFoldersAccounts', 'savingsAccounts.accounts'), _dec4 = computed('foldersAccounts.openFoldersAccounts', 'savingsAccounts.accounts'), _dec5 = computed('doesRainyDayExist'), _dec6 = computed('doesTaxExist'), _dec7 = computed('doesPayrollExist'), _dec8 = computed('doesRentExist'), _class = class SelectCategory extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "savingsAccounts", _descriptor2, this);
    _initializerDefineProperty(this, "foldersAccounts", _descriptor3, this);
    _initializerDefineProperty(this, "dataApi", _descriptor4, this);
    _defineProperty(this, "categories", SAVINGS_CATEGORIES_TO_ENUMS);
    _defineProperty(this, "selectSubflow", void 0);
    _defineProperty(this, "onSalesTaxSelect", void 0);
    _defineProperty(this, "showSalesTaxRow", void 0);
  }
  didInsertElement() {
    super.didInsertElement();
    const {
      name,
      properties
    } = getEvent(Action.View, {
      page: Page.CreateFolder
    });
    this.dataApi.track(name, properties);
  }
  get doesRainyDayExist() {
    if (this.features.isEnabled('banking/access_sfs_savings')) {
      return this.savingsAccounts.accounts.some(account => account.metadata?.savingsAccount?.category === SAVINGS_CATEGORIES_TO_ENUMS.RainyDay && account.state !== AccountState.CLOSED);
    }
    return this.foldersAccounts.openFoldersAccounts.some(account => account.category === SAVINGS_CATEGORIES_TO_ENUMS.RainyDay);
  }
  get doesTaxExist() {
    const targetCategory = this.showSalesTaxRow ? SavingsAccountMetadata.Category.SALES_TAX : SAVINGS_CATEGORIES_TO_ENUMS.Tax;
    if (this.features.isEnabled('banking/access_sfs_savings')) {
      return this.savingsAccounts.accounts.some(account => account.metadata?.savingsAccount?.category === targetCategory && account.state !== AccountState.CLOSED);
    }
    return this.foldersAccounts.openFoldersAccounts.some(account => account.category === SAVINGS_CATEGORIES_TO_ENUMS.Tax);
  }
  get doesPayrollExist() {
    if (this.features.isEnabled('banking/access_sfs_savings')) {
      return this.savingsAccounts.accounts.some(account => account.metadata?.savingsAccount?.category === SAVINGS_CATEGORIES_TO_ENUMS.Payroll && account.state !== AccountState.CLOSED);
    }
    return this.foldersAccounts.openFoldersAccounts.some(account => account.category === SAVINGS_CATEGORIES_TO_ENUMS.Payroll);
  }
  get doesRentExist() {
    if (this.features.isEnabled('banking/access_sfs_savings')) {
      return this.savingsAccounts.accounts.some(account => account.metadata?.savingsAccount?.category === SAVINGS_CATEGORIES_TO_ENUMS.Rent && account.state !== AccountState.CLOSED);
    }
    return this.foldersAccounts.openFoldersAccounts.some(account => account.category === SAVINGS_CATEGORIES_TO_ENUMS.Rent);
  }
  get rainyDaySvg() {
    if (this.doesRainyDayExist) {
      return '18px-check';
    } else {
      return '24px-cloud';
    }
  }
  get taxSvg() {
    if (this.doesTaxExist) {
      return '18px-check';
    } else {
      return '24px-percentage';
    }
  }
  get payrollSvg() {
    if (this.doesPayrollExist) {
      return '18px-check';
    } else {
      return '24px-payroll';
    }
  }
  get rentSvg() {
    if (this.doesRentExist) {
      return '18px-check';
    } else {
      return '24px-buildings';
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "savingsAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "foldersAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "doesRainyDayExist", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "doesRainyDayExist"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doesTaxExist", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "doesTaxExist"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doesPayrollExist", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "doesPayrollExist"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doesRentExist", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "doesRentExist"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rainyDaySvg", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "rainyDaySvg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "taxSvg", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "taxSvg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "payrollSvg", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "payrollSvg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rentSvg", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "rentSvg"), _class.prototype), _class);
export { SelectCategory as default };